import getCharts from '../getCharts'
import { PatientImagingDataCrud } from '../../constants/api.config'

export default async function PatientImagingsCRUD(mode, patientID = "-1", data = "", newDate = "-1", id = "-1") {
    try {
        const payload = { mode, data, patientID, id, newDate }
        const res = await getCharts(PatientImagingDataCrud, payload)
        return res.data
    } catch (error) {
        return error
    }
}
